import { ChainConfiguration } from '../utils/types'

export const POLYGON_CONFIG: ChainConfiguration = {
  chain: 'Mainnet',
  network: 'Polygon',
  appId: 137,
  nativeCurrency: {
    name: 'Wrapped MATIC',
    symbol: 'WMATIC', // 2-6 characters long
    decimals: 18,
  },
  rpcUrls: ['https://polygon-rpc.com'],
  blockExplorerUrls: ['https://polygonscan.com'],
  getExplorerUrl: function (transactionHash: string) {
    return `https://polygonscan.com/tx/${transactionHash}`
  },
  getExplorerPoolUrl: function (transactionHash: string) {
    return `https://polygonscan.com/address/${transactionHash}`
  },
}

export const POLYGON = {
  THE_GRAPH_URL:
    'https://api.goldsky.com/api/public/project_clws2t7g7ae9c01xsbnu80a51/subgraphs/swaapv1/1.0.0/gn',
  FACTORY: '0xd682a62bd1dF757616e68319720295Ff7667A847',
  PROXY: '0xe63e0f7526397a2900F870eF9Df6b52CB6330755',
  POOL: '0x7f5f7411c2c7ec60e2db946abbe7dc354254870b',
}
